/* Blassen Studios — Scroll-Animationen (blassen.js)
   Dezente Einblendungen beim Scrollen. Respektiert prefers-reduced-motion. */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var SELEKTOREN = [
    '.bs2-tiles__grid > *',
    '.bs-product-grid > *',
    '.bs2-philosophy__inner',
    '.bs2-local__text',
    '.bs2-local__media',
    '.bs2-editorial__item',
    '.bs2-cta__text',
    '.bs2-split__media',
    '.bs2-split__body',
    '.bs2-why__head',
    '.bs2-why__item',
    '.bs-acc__item',
    '.bs2-hero__title',
    '.bs2-hero__bottom',
    '.bs-uspband__eyebrow',
    '.bs-uspband__row',
    '.bs-testi__card',
    '.bs-prozess__head',
    '.bs-prozess__step',
    '.bs2-timeline__list',
    '.bs2-timeline__item'
  ];

  var elemente = document.querySelectorAll(SELEKTOREN.join(','));
  if (!elemente.length) return;

  elemente.forEach(function (el, i) {
    el.classList.add('bs-reveal');
    /* Staffelung innerhalb von Grids */
    var parent = el.parentElement;
    if (parent) {
      var geschwister = Array.prototype.indexOf.call(parent.children, el);
      el.style.transitionDelay = Math.min(geschwister * 80, 400) + 'ms';
    }
  });

  var beobachter = new IntersectionObserver(function (eintraege) {
    eintraege.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('bs-reveal--sichtbar');
        beobachter.unobserve(e.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

  elemente.forEach(function (el) { beobachter.observe(el); });
})();

/* Zeitstrahl: feste Fortschrittslinie am Bildrand.
   Erscheint ab dem Hero, füllt sich beim Scrollen bis zum Seitenende, Kopf fährt mit. */
(function () {
  var hero = document.querySelector('.bs2-hero');

  function heroBottomDoc() {
    if (!hero) return 0;
    var r = hero.getBoundingClientRect();
    return r.top + window.scrollY + r.height;
  }

  function update() {
    var rail = document.querySelector('[data-bs-rail]');
    if (!rail) return;
    var vh = window.innerHeight;
    var hb = heroBottomDoc();
    var startY = hb - vh;
    if (startY < 0) startY = 0;
    var endY = document.documentElement.scrollHeight - vh;
    if (endY <= startY) endY = startY + 1;
    var f = Math.min(1, Math.max(0, (window.scrollY - startY) / (endY - startY)));
    var pct = f * 100;

    rail.classList.toggle('is-visible', window.scrollY > hb - vh * 0.9);

    var prog = rail.querySelector('[data-rail-progress]');
    if (prog) prog.style.height = pct + '%';
    var head = rail.querySelector('[data-rail-head]');
    if (head) {
      head.style.top = pct + '%';
      head.style.opacity = (pct > 0.5 && pct < 99.5) ? '1' : '0';
    }
  }

  var ticking = false;
  window.addEventListener('scroll', function () {
    if (!ticking) { requestAnimationFrame(function () { update(); ticking = false; }); ticking = true; }
  }, { passive: true });
  window.addEventListener('resize', update, { passive: true });
  window.addEventListener('load', update);
  document.addEventListener('shopify:section:load', update);
  update();
})();

/* Kundenstimmen-Karussell: dezente Pfeile, nur sichtbar wenn mehr Karten als Platz */
(function () {
  function initTesti(scope) {
    (scope || document).querySelectorAll('[data-testi-carousel]').forEach(function (car) {
      if (car.dataset.testiInit) return;
      car.dataset.testiInit = '1';
      var track = car.querySelector('[data-testi-track]');
      if (!track) return;
      var prev = car.querySelector('[data-testi-prev]');
      var next = car.querySelector('[data-testi-next]');
      function step() {
        var card = track.querySelector('.bs-testi__card');
        var styles = getComputedStyle(track);
        var gap = parseFloat(styles.columnGap || styles.gap) || 24;
        return card ? card.offsetWidth + gap : track.clientWidth * 0.8;
      }
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      function updateNav() {
        var overflow = track.scrollWidth > track.clientWidth + 4;
        if (prev) prev.hidden = !overflow;
        if (next) next.hidden = !overflow;
      }
      updateNav();
      window.addEventListener('resize', updateNav, { passive: true });
      window.addEventListener('load', updateNav);
    });
  }
  initTesti();
  document.addEventListener('shopify:section:load', function (e) { initTesti(e.target); });
})();

/* Foto einsenden: Drag & Drop + Dateinamen-Anzeige */
(function () {
  function initFoto(scope) {
    (scope || document).querySelectorAll('[data-foto-drop]').forEach(function (zone) {
      if (zone.dataset.fotoInit) return;
      zone.dataset.fotoInit = '1';
      var input = zone.querySelector('[data-foto-input]');
      var list = zone.querySelector('[data-foto-list]');
      if (!input) return;
      function render() {
        if (list) {
          list.innerHTML = '';
          Array.prototype.forEach.call(input.files, function (f) {
            var li = document.createElement('li');
            li.textContent = f.name;
            list.appendChild(li);
          });
        }
        zone.classList.toggle('has-files', input.files.length > 0);
      }
      input.addEventListener('change', render);
      ['dragenter', 'dragover'].forEach(function (ev) {
        zone.addEventListener(ev, function (e) { e.preventDefault(); zone.classList.add('is-drag'); });
      });
      ['dragleave', 'dragend'].forEach(function (ev) {
        zone.addEventListener(ev, function () { zone.classList.remove('is-drag'); });
      });
      zone.addEventListener('drop', function (e) {
        e.preventDefault();
        zone.classList.remove('is-drag');
        if (e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files.length) {
          try { input.files = e.dataTransfer.files; } catch (err) {}
          render();
        }
      });
    });
  }
  initFoto();
  document.addEventListener('shopify:section:load', function (e) { initFoto(e.target); });
})();

/* Skizzen-Verlauf: fixer Hintergrund, blendet nach Scroll-Fortschritt von Bild 1 → 2 → 3 */
(function () {
  var wm, layers, maxOp;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function set() {
    if (!wm || !layers || !layers.length) return;
    if (reduce) { layers[0].style.opacity = maxOp; return; }
    var h = document.documentElement.scrollHeight - window.innerHeight;
    var p = h > 0 ? Math.min(Math.max(window.scrollY / h, 0), 1) : 0;
    var n = layers.length;
    if (n === 1) { layers[0].style.opacity = maxOp; return; }
    var pos = p * (n - 1);
    layers.forEach(function (el, i) {
      var w = Math.max(0, 1 - Math.abs(pos - i));
      el.style.opacity = (w * maxOp).toFixed(3);
    });
  }

  function init() {
    wm = document.querySelector('[data-wm]');
    if (!wm) return;
    layers = Array.prototype.slice.call(wm.querySelectorAll('[data-wm-layer]'));
    if (!layers.length) return;
    maxOp = parseFloat(wm.getAttribute('data-wm-op'));
    if (isNaN(maxOp)) maxOp = 0.12;
    set();
  }

  var ticking = false;
  window.addEventListener('scroll', function () {
    if (!ticking) { requestAnimationFrame(function () { set(); ticking = false; }); ticking = true; }
  }, { passive: true });
  window.addEventListener('resize', set, { passive: true });
  window.addEventListener('load', init);
  /* Editor: reagiert, wenn die Sektion ein-/umgebaut wird */
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', init);
  init();
})();
